import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import connect from 'scripts/presentation/components/lib/connect';
import { resolveVariables } from 'scripts/domain/models/kb_variable';

export const DEFAULT_CONTEXT = {};

const VariablesContext = React.createContext(DEFAULT_CONTEXT);
export { VariablesContext };

export class VariablesContextProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...getResolvedVariables(props),
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.agentImm !== state.agentImm ||
      props.customerProfileImm !== state.customerProfileImm ||
      props.variablesImm !== state.variablesImm
    ) {
      return {
        ...getResolvedVariables(props),
      };
    }

    return null;
  }

  render() {
    return <VariablesContext.Provider value={this.state.variables}>{this.props.children}</VariablesContext.Provider>;
  }
}

VariablesContextProvider.propTypes = {
  children: PropTypes.node,
};

function getResolvedVariables({
  agentImm,
  agentProvider,
  customerProfileImm,
  customerProfileProvider,
  variablesImm,
  variablesProvider,
}) {
  const variableModels = variablesProvider.findAll();

  const agent = agentProvider.get();
  const customerProfile = customerProfileProvider.get();

  const variables = resolveVariables(variableModels, {
    agent,
    customerProfile,
  });

  return {
    agentImm,
    customerProfileImm,
    variablesImm,
    variables,
  };
}

const VariablesProvider = connect(mapStateToProps)(VariablesContextProvider);
export default VariablesProvider;

function mapStateToProps({ getProvider }) {
  return {
    agentImm: getProvider('currentAgent').store.binding.get(),
    agentProvider: getProvider('currentAgent'),
    customerProfileImm: getProvider('profile').store.binding.get(),
    customerProfileProvider: getProvider('profile'),
    variablesImm: getProvider('kbVariables').immutableStore.binding.get(),
    variablesProvider: getProvider('kbVariables'),
  };
}

export function useVariables() {
  return useContext(VariablesContext);
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/contexts/variables_context.jsx